export default "__VITE_PUBLIC_ASSET__9758a2a6__"